import React, { useState, useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { createSelector } from "reselect";
import UserDetails from "./UserDetails";
import CustomPagination from "../../Components/Common/CustomePagination";
import Skeleton from "react-loading-skeleton";
import {
  addAdmin,
  fetchAdminsList,
  updateAdminStatus,
} from "../../slices/Admin/thunk";
import AdminForm from "./AdminForm";
import EditAdminStatusModal from "./AdminStatusModal";

const UserList = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editUserData, setEditUserData] = useState(null);

  const selectUserListState = (state) => state;
  const userListSelector = createSelector(selectUserListState, (state) => ({
    users: state.Admin.admins,
    loading: state.UserList.loading,
    error: state.UserList.error,
    pagination: state.UserList.pagination,
  }));

  const { users, loading, error, pagination } = useSelector(userListSelector);

  const filteredUsers = users;

  const handleToggleStatus = async (userId, currentStatus) => {
    const newStatus = !currentStatus;
    await dispatch(updateAdminStatus(userId, newStatus));
  };

  const handleUserRowClick = (userId) => {
    setSelectedUserId(userId);
    setIsUserModalOpen(true);
  };

  const handleAddAdmin = async (values) => {
    await dispatch(addAdmin(values));
    await dispatch(fetchAdminsList());
    setShowAddForm(false);
  };

  const handleEdit = async (user) => {
    // await dispatch(updateAdminStatus(user.id, user.active));
    setEditUserData(user);
    setOpenEditModal(true);
  };

  const handleEditAdminStatus = async (id, updatedUser) => {
    
    await dispatch(updateAdminStatus(id, updatedUser));
    await dispatch(fetchAdminsList());
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  useEffect(() => {
    const params = {
      pageNo,
      pageSize,
      sortBy: "createdAt",
      sortOrder: "DESC",
      isPagination: 1,
      searchTerm: debouncedSearch.trim(),
    };
    dispatch(fetchAdminsList(params));
  }, [dispatch, pageNo, pageSize, debouncedSearch]);

  document.title = "Admins";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2 w-100 justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <h4 className="card-title mb-0">
                        {showAddForm ? "Add Transport" : "Transport List"}
                      </h4>

                      {!showAddForm && (
                        <div className="search-box">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setPageNo(0);
                            }}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      )}
                    </div>

                    {/* RIGHT SIDE → Add / Back Button */}
                    <button
                      className={`btn btn-sm ${
                        showAddForm ? "btn-secondary" : "btn-success"
                      }`}
                      onClick={() => setShowAddForm(!showAddForm)}
                    >
                      <i
                        className={
                          showAddForm ? "ri-arrow-left-line" : "ri-add-line"
                        }
                      ></i>{" "}
                      {showAddForm ? "Back to Listing" : "Add Transport"}
                    </button>
                  </div>
                </CardHeader>

                <CardBody className="d-flex flex-column">
                  {showAddForm ? (
                    <AdminForm
                      onBack={() => setShowAddForm(false)}
                      onSubmit={(values) => handleAddAdmin(values)}
                    />
                  ) : (
                    <>
                      <div className="flex-grow-1 overflow-auto">
                        <table
                          className="table align-middle table-nowrap"
                          id="customerTable"
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Sr. No</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading && (
                              <>
                                {[...Array(pageSize)].map((_, index) => (
                                  <tr key={index}>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <Skeleton height={15} width={40} />
                                      </div>
                                    </td>

                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={80} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={150} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={80} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={60} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={60} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={60} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={60} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={40} />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-start">
                                        <Skeleton height={15} width={30} />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </>
                            )}

                            {error && (
                              <tr>
                                {/* <td colSpan="7" className="text-center text-danger">
                              {error}
                            </td> */}
                              </tr>
                            )}
                            {!loading && users?.length === 0 && (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center text-danger"
                                >
                                  No users found.
                                </td>
                              </tr>
                            )}

                            {!loading &&
                              filteredUsers?.map((user, index) => {
                                const endDate = user?.subscription?.endDate;

                                const parseDate = (dateStr) => {
                                  if (!dateStr) return null;
                                  const [day, month, year] = dateStr.split("-");
                                  return new Date(`${year}-${month}-${day}`);
                                };

                                const today = new Date();
                                const subscriptionStatus =
                                  user?.subscription?.status;
                                const isExpired =
                                  subscriptionStatus === "ACTIVE" &&
                                  endDate &&
                                  parseDate(endDate) < today;

                                return (
                                  <tr
                                    key={index}
                                    onClick={() => handleUserRowClick(user?.id)}
                                    style={{
                                      cursor: "pointer",

                                      // backgroundColor: isExpired
                                      //   ? "#f8d7da"
                                      //   : "transparent",
                                      // color: isExpired ? "#842029" : "inherit",
                                    }}
                                  >
                                    <td>{pageNo * pageSize + index + 1}</td>
                                    <td>{user?.name}</td>
                                    <td>{user?.email || "-"} </td>
                                    <td>{user?.mobileNo || "-"}</td>
                                    <td>{user?.startDate || "-"}</td>
                                    <td>{user?.expiryDate || "-"}</td>

                                    <td onClick={(e) => e.stopPropagation()}>
                                      {user?.active ? (
                                        <Badge
                                          color="success"
                                          className="px-3 py-2"
                                        >
                                          Active
                                        </Badge>
                                      ) : (
                                        <Badge
                                          color="danger"
                                          className="px-3 py-2"
                                        >
                                          Inactive
                                        </Badge>
                                      )}
                                    </td>

                                    <td onClick={(e) => e.stopPropagation()}>
                                      <Button
                                        color="warning"
                                        size="sm"
                                        className="px-3 py-1 d-flex align-items-center gap-1"
                                        onClick={() => handleEdit(user)}
                                      >
                                        <i className="ri-edit-line"></i> Edit
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex flex-column">
                        <div className="mt-3" style={{ minHeight: "50px" }}>
                          <CustomPagination
                            currentPage={pagination?.currentPage}
                            totalPages={pagination?.totalPages}
                            onPageChange={(page) => setPageNo(page)}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            setPageNo={setPageNo}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {selectedUserId && (
        <UserDetails
          id={selectedUserId}
          isOpen={isUserModalOpen}
          onClose={() => setIsUserModalOpen(false)}
        />
      )}
      <EditAdminStatusModal
        isOpen={openEditModal}
        user={editUserData}
        toggle={() => setOpenEditModal(!openEditModal)}
        onSubmit={handleEditAdminStatus}
      />
    </React.Fragment>
  );
};

export default UserList;
